module.exports = __webpack_public_path__ + "img/KinokoTable45.ab01596e.jpg";